























import Vue from "vue";
import axios from "axios";
import { Location } from "vue-router";
import RouteNames from "@/router/RouteNames.ts";
import UserInfo from "@/components/UserInfo.vue";
import { MetadataItem } from "@/model/DataViewConfigurationHelper";
import DefaultAdminMetaModel from "@/model/DefaultAdminMetaModel.json";
import InitDiagnosezentrenModel from "@/model/InitDiagnosezentrenModel.json";

export default Vue.extend({
  name: "TheNavigationDrawer",

  components: {
    UserInfo
  },

  props: {
    value: Boolean
  },

  mounted() {
    this.loadDataViews();
  },

  watch: {
    "$root.$data.user"() {
      this.loadDataViews();
    }
  },

  methods: {
    async seedAdminMetamodel() {
      const updateUrl = `${process.env.VUE_APP_API_URL}/model/meta/update`;
      await axios.post(updateUrl, {
        selector: { attributes: { collection: "meta" } },
        attributes: DefaultAdminMetaModel
      });
      await axios.post(updateUrl, {
        selector: {
          attributes: { collection: InitDiagnosezentrenModel.collection }
        },
        attributes: InitDiagnosezentrenModel
      });
    },
    async loadDataViews() {
      if (!this.isObjectsReadAllowed) {
        this.dataViews = [];
        return;
      }
      const listUrl = `${process.env.VUE_APP_API_URL}/model/meta/list`;

      let responses = await axios.get<MetadataItem[]>(listUrl);

      if (
        responses.data.length < 1 ||
        responses.data.findIndex(
          item => item.attributes?.collection === "meta"
        ) < 0
      ) {
        await this.seedAdminMetamodel();
        responses = await axios.get<MetadataItem[]>(listUrl);
      }

      this.dataViews = responses.data
        .filter((metaItem: any) => {
          if (
            metaItem.attributes &&
            metaItem.attributes.roles &&
            !this.checkRoles(...metaItem.attributes.roles)
          ) {
            return false;
          }
          return true;
        })
        .sort(
          (a, b) =>
            Number.parseInt(a.attributes.order ?? "0") -
            Number.parseInt(b.attributes?.order ?? "0")
        )
        .map<{
          label: string;
          icon: string;
          route: Location;
        }>((metaItem: any) => ({
          label: metaItem.attributes.displayName,
          icon: metaItem.attributes.icon,
          route: {
            name: RouteNames.DATAVIEW,
            params: {
              kind: metaItem.attributes.route
            }
          }
        }));
    }
  },

  computed: {
    listItems(): Array<{ label: string; icon: string; route: Location }> {
      return [
        {
          label: "Startseite",
          icon: "mdi-home",
          route: { name: RouteNames.HOME }
        },
        ...this.dataViews,
        // {
        //   label: "Dateiablage",
        //   icon: "mdi-file-chart",
        //   route: { name: RouteNames.FILES }
        // },
        {
          label: "Impressum",
          icon: "mdi-information",
          route: { name: RouteNames.ABOUT }
        }
      ];
    }
  },

  data: () => ({
    dataViews: [] as any[]
  })
});
